import ColorPickerToolTip from "components/ColorPickerToolTip";
import ImageToolTip from "components/ImageToolTip";
import TextToolTip from "components/TextToolTip";

export default function ToolTipSelector({ component, props }) {
  switch (component) {
    case "ColorPickerToolTip":
      return (
        <ColorPickerToolTip backgroundColor={props?.backgroundColor}>
          {props?.label}
        </ColorPickerToolTip>
      );

    case "ImageToolTip":
      return (
        <ImageToolTip
          labelImage={props?.labelImage}
          image={props?.image}
          imageWidth={props?.imageWidth}
          imageHeight={props?.imageHeight}
          backgroundColor={props?.backgroundColor}
          dangerouslySetLabel={props.label_HTML}
        >
          {props?.label}
        </ImageToolTip>
      );

    default:
      return (
        <TextToolTip dangerouslySetLabel={props.label_HTML}>
          {props?.label}
        </TextToolTip>
      );
  }
}
